// extracted by mini-css-extract-plugin
export var label = "_9w-1";
export var reminder = "_9w-0";